
import { defineComponent } from "vue";
import NavBar from "@/components/navigation/NavBar.vue";
import Footer from "@/components/Footer.vue";

export default defineComponent({
    components: { NavBar, Footer },
});
